import { ZodObject } from 'zod'

let instance: AppConfig | null = null

export class AppConfig {
  private config?: object

  constructor() {
    if (!instance) {
      instance = this
    }
  }

  setConfig(config: object): void {
    this.config = config
  }

  getConfig(): object | undefined {
    return this.config
  }
}

/**
 * The configuration singleton object to get config of the current app.
 * @returns AppConfig singleton object
 * @example
 * ```typescript
 * import { configClient } from 'clients'
 * const config = configClient.getConfig()
 * ```
 */
export const configClient = new AppConfig()

export function isValidConfig(config: Record<string, any>, configSchema: ZodObject<any>) {
  const schemaShape = configSchema.shape

  for (const key in schemaShape) {
    if (!(key in config)) {
      return false
    }

    const schemaType = schemaShape[key]
    const value = config[key]

    if (schemaType instanceof ZodObject) {
      if (typeof value !== 'object' || value === null) {
        return false
      }
      if (!isValidConfig(value, schemaType)) {
        return false
      }
    }
  }
  return true
}
